import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { CONTACT } from "../data/products";

export const WhatsAppFloat = () => (
    <motion.a
        href={`https://wa.me/${CONTACT.phoneIntl}`}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-float-button"
        aria-label="Chat on WhatsApp"
        className="fixed bottom-5 right-5 sm:bottom-8 sm:right-8 z-50 flex items-center gap-0 bg-[#25D366] text-white p-4 rounded-full shadow-[0_8px_30px_rgba(37,211,102,0.4)] hover:shadow-[0_8px_30px_rgba(37,211,102,0.6)] transition-shadow"
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 1.6, type: "spring", stiffness: 260, damping: 18 }}
        whileHover={{ scale: 1.08 }}
        whileTap={{ scale: 0.94 }}
    >
        <MessageCircle className="w-6 h-6" fill="currentColor" />
    </motion.a>
);
